import { CertificateService } from '@openeducation/oe-rn-services';

import { useEnvironmentContext } from '../environment/environment.provider';

export const useGetCertificateDownloadUrl = () => {
  const { environment } = useEnvironmentContext();

  const getCertificateDownloadUrl = (level: number, contactId?: string) =>
    CertificateService.getCertificateDownloadUrl(environment, level, contactId);

  return { getCertificateDownloadUrl };
};
